/**
 * TodoUpdater.ts
 *
 * Todo 항목의 업데이트를 담당하는 모듈
 * dueDate, reminder 등의 필드 업데이트 로직 구현
 */

import { updateTask } from './TodoManager'
import { TodoItem, TaskReminder } from './TodoItem'
import { RRule } from 'rrule'

export interface TodoUpdateOptions {
  dueDate?: Date | null
  alarms?: TaskReminder[]
  priority?: string
  status?: string
  startDate?: Date | null
  recurrenceRule?: RRule | null
}

/**
 * Todo 항목의 dueDate를 업데이트
 */
export const updateTodoDueDate = (
  todo: TodoItem,
  dueDate: Date | null,
  callback?: (success: boolean) => void,
): void => {
  try {
    const updatedTodo = {
      ...todo,
      dueDate: dueDate,
    }

    updateTask(todo.url, todo.etag, updatedTodo, null, (success) => {
      if (!success) {
        console.error('[updateTodoDueDate] Due date update failed')
      }

      if (callback) callback(success)
    })
  } catch (error) {
    console.error('Error updating todo due date:', error)
    if (callback) callback(false)
  }
}

/**
 * Todo 항목의 알람(reminder)을 업데이트
 */
export const updateTodoReminder = (
  todo: TodoItem,
  alarms: TaskReminder[],
  startDate?: Date | null,
  callback?: (success: boolean) => void,
): void => {
  try {
    const updatedTodo = {
      ...todo,
      alarms: alarms,
      ...(startDate !== undefined && { startDate: startDate }),
    }

    updateTask(todo.url, todo.etag, updatedTodo, null, (success) => {
      if (!success) {
        console.error('[updateTodoReminder] Reminder update failed')
      }

      if (callback) callback(success)
    })
  } catch (error) {
    console.error('Error updating todo reminder:', error)
    if (callback) callback(false)
  }
}

/**
 * Todo 항목의 recurrence를 업데이트
 */
export const updateTodoRecurrence = (
  todo: TodoItem,
  recurrenceRule: RRule | null,
  dueDate?: Date | null,
  callback?: (success: boolean) => void,
): void => {
  try {
    const updatedTodo = {
      ...todo,
      recurrenceRule: recurrenceRule,
      ...(dueDate !== undefined && { dueDate: dueDate }),
      // recurrence가 설정되면 startDate도 설정 (RFC 5545 요구사항)
      ...(recurrenceRule && dueDate && { startDate: dueDate }),
      // recurrence가 제거되면 startDate도 제거
      ...(recurrenceRule === null && { startDate: null }),
    }

    updateTask(todo.url, todo.etag, updatedTodo, null, (success) => {
      if (!success) {
        console.error('[updateTodoRecurrence] Recurrence update failed')
      }

      if (callback) callback(success)
    })
  } catch (error) {
    console.error('Error updating todo recurrence:', error)
    if (callback) callback(false)
  }
}
